import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';
import AuthModal from './AuthModal';
import { maskUsername } from '@/utils/common';
export default function Header() {
  // 获取登录信息
  let userInfo: any = null;
  try {
    const local = localStorage.getItem('userInfo');
    if (local) {
      const parsed = JSON.parse(local);
      userInfo = parsed;
    }
  } catch {}

  const [showUserMenu, setShowUserMenu] = useState(false);
  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('authToken');
    window.location.href = '/';
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'register'>('login');
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleAuthClick = (mode: 'login' | 'register') => {
    setAuthMode(mode);
    setShowAuthModal(true);
    setIsMenuOpen(false);
  };

  const navigationItems = [
    { name: '首页', path: '/', icon: 'ri-home-line' },
    { name: '直播', path: '/live', icon: 'ri-live-line' },
    { name: '赛事', path: '/matches', icon: 'ri-calendar-event-line' },
    { name: '新闻', path: '/news', icon: 'ri-newspaper-line' },
    { name: '社区', path: '/community', icon: 'ri-group-line' },
    { name: '账户', path: '/profile', icon: 'ri-user-line' }
  ];

  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-40">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/73c91a15dd5fc3286d8e8dabba47af47/554f967f7a6583958f1f78511eb1d222.png" 
                alt="SportLive Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                贝斯特体育
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navigationItems.map(item => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`transition-colors cursor-pointer ${
                    location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))
                      ? 'text-green-600 font-medium border-b-2 border-green-600 pb-1'
                      : 'text-gray-600 hover:text-green-600'
                  }`}
                  onClick={e => {
                    if (!userInfo || !userInfo.username) {
                      e.preventDefault();
                      handleAuthClick('login');
                    }
                  }}
                >
                  <i className={`${item.icon} text-lg mr-1`}></i>
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* Desktop 用户信息或登录注册按钮 */}
            <div className="hidden md:flex items-center space-x-3 relative">
              {userInfo && userInfo.username ? (
                <div className="flex items-center space-x-2 cursor-pointer select-none relative" onClick={() => setShowUserMenu(v => !v)}>
                  <img
                    src="https://static.readdy.ai/image/73c91a15dd5fc3286d8e8dabba47af47/554f967f7a6583958f1f78511eb1d222.png"
                    alt="avatar"
                    className="w-8 h-8 rounded-full object-cover border border-gray-200"
                  />
                  <span className="text-sm font-medium text-gray-700">{maskUsername(userInfo.username)}</span>
                  <i className="ri-arrow-down-s-line text-gray-400 text-base"></i>
                  {/* 下拉菜单 */}
                  {showUserMenu && (
                    <div className="absolute top-10 right-0 w-40 bg-white rounded-lg shadow-lg border z-50 animate-in fade-in duration-200">
                      <Link to="/profile" className="block px-4 py-3 text-gray-700 hover:bg-gray-50">个人中心</Link>
                      <button onClick={handleLogout} className="block w-full text-left px-4 py-3 text-red-600 hover:bg-red-50">退出登录</button>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleAuthClick('login')}
                    className="text-sm whitespace-nowrap"
                  >
                    登录
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleAuthClick('register')}
                    className="text-sm whitespace-nowrap"
                  >
                    注册
                  </Button>
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMenu}
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-gray-600`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - 新开层模式 */}
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 z-50">
          {/* 背景遮罩 */}
          <div 
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setIsMenuOpen(false)}
          ></div>
          
          {/* 菜单面板 */}
          <div className="absolute top-0 right-0 w-80 max-w-[90vw] h-full bg-white shadow-2xl transform transition-transform duration-300">
            {/* 菜单头部 */}
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <div className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/73c91a15dd5fc3286d8e8dabba47af47/554f967f7a6583958f1f78511eb1d222.png" 
                  alt="SportLive Logo" 
                  className="h-8 w-auto"
                />
                <span className="text-lg font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                  贝斯特体育
                </span>
              </div>
              <button
                onClick={() => setIsMenuOpen(false)}
                className="w-8 h-8 flex items-center justify-center cursor-pointer text-gray-500 hover:text-gray-700"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {/* 导航菜单 */}
            <nav className="p-4">
              <div className="space-y-2">
                {navigationItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer ${
                      location.pathname === item.path
                        ? 'text-green-600 bg-green-50 font-medium'
                        : 'text-gray-600 hover:text-green-600 hover:bg-green-50'
                    }`}
                  >
                    <i className={`${item.icon} text-lg`}></i>
                    <span>{item.name}</span>
                  </Link>
                ))}
              </div>
              
              {/* 移动端用户信息或登录注册按钮 */}
              <div className="mt-6 pt-4 border-t border-gray-100">
                {userInfo && userInfo.username ? (
                  <div className="flex items-center space-x-3 px-4 py-3">
                    <img
                      src="https://static.readdy.ai/image/73c91a15dd5fc3286d8e8dabba47af47/554f967f7a6583958f1f78511eb1d222.png"
                      alt="avatar"
                      className="w-8 h-8 rounded-full object-cover border border-gray-200"
                    />
                    <span className="text-sm font-medium text-gray-700">{userInfo.username}</span>
                    <Link to="/profile" className="ml-auto text-green-600 hover:underline">个人中心</Link>
                    <button onClick={handleLogout} className="ml-2 text-red-600 hover:underline">退出</button>
                  </div>
                ) : (
                  <div className="flex space-x-3">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleAuthClick('login')}
                      className="flex-1 text-sm whitespace-nowrap"
                    >
                      登录
                    </Button>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => handleAuthClick('register')}
                      className="flex-1 text-sm whitespace-nowrap"
                    >
                      注册
                    </Button>
                  </div>
                )}
              </div>

              {/* 额外功能区域 */}
              <div className="mt-6 pt-4 border-t border-gray-100">
                <div className="text-sm text-gray-500 mb-3">快捷功能</div>
                <div className="space-y-2">
                  <button className="flex items-center space-x-3 w-full px-4 py-3 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors cursor-pointer">
                    <i className="ri-download-line text-lg"></i>
                    <span>下载APP</span>
                  </button>
                  <button className="flex items-center space-x-3 w-full px-4 py-3 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors cursor-pointer">
                    <i className="ri-customer-service-line text-lg"></i>
                    <span>客服帮助</span>
                  </button>
                  <button className="flex items-center space-x-3 w-full px-4 py-3 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors cursor-pointer">
                    <i className="ri-settings-line text-lg"></i>
                    <span>设置</span>
                  </button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      )}

      {/* Auth Modal */}
      {showAuthModal && (
        <AuthModal
          mode={authMode}
          onClose={() => setShowAuthModal(false)}
          onSwitchMode={(mode) => setAuthMode(mode)}
        />
      )}
    </>
  );
}